import { render, staticRenderFns } from "./pane-notifications.vue?vue&type=template&id=542fa850&scoped=true"
import script from "./pane-notifications.vue?vue&type=script&lang=js"
export * from "./pane-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542fa850",
  null
  
)

export default component.exports